import nlp from "compromise";

const normalizeWord = (word) => String(word || "").toLowerCase().trim();

const uniqueWords = (list) => {
  const out = [];
  const seen = new Set();
  list.forEach((w) => {
    const norm = normalizeWord(w);
    if (!norm || seen.has(norm)) return;
    seen.add(norm);
    out.push(norm);
  });
  return out;
};

export const extractPosWords = (text, posType) => {
  const safeText = String(text || "");
  if (!safeText.trim()) return [];
  const doc = nlp(safeText);

  let terms = [];
  switch (posType) {
    case "verb":
      terms = doc.verbs().out("array");
      break;
    case "adjective":
      terms = doc.adjectives().out("array");
      break;
    case "adverb":
      terms = doc.adverbs().out("array");
      break;
    case "noun":
    default:
      terms = doc.nouns().out("array");
      break;
  }

  const flattened = terms.flatMap((term) => String(term).split(/\s+/));
  return uniqueWords(flattened);
};